module.exports = __webpack_public_path__ + "img/cdKey.7e266835.png";